/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  IonButton,
  IonCheckbox,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonHeader,
  IonLabel,
  IonPage,
  IonRow,
} from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router";
import { useRecoilState } from "recoil";
import TopLeftUserName from "../components/TopLeftUserName";
import {
  createPatientStep2State,
  dummyDropDowns,
  newAllDropDownState,
  PatientState,
  dummyPatient,
  resetDropDowns,
  networkConnectionStatus,
} from "../data/atoms";
import { ActionType, BusinessType } from "../models/Enums";
import {
  AddUpdateMobileWorkstationPatient,
  GetRecentSearchesAuth,
  SaveRecentSearchAuth,
} from "../services/AuthServices";
import { getMobileUIVersion } from "../utils/api-interceptor";
import SearchBar from "../components/SearchBar";
import { localDateTime } from "../utils/sharedFunction";
import { format } from "date-fns";
import { deviceUniqueId } from "../utils/mobile-bridge";
import * as Sentry from "@sentry/react";
class recentSearch {
  fullName: string;
  patientid: number;
}
const Home: React.FC = () => {
  const [showModal, setShowModal] = useState(false);
  // const [patientName, setpatientName] = useState<string>(localStorage.getItem("patientSearched")!);
  const [patientName, setpatientName] = useState<string>("");
  const [isDC, setIsDC] = useState<boolean>(true);
  const isPccEnabled = localStorage.getItem("isPccEnabled") === "true";
  const [isPccCheck, setIsPccCheck] = useState<boolean>(isPccEnabled);

  const [newAllDropDown, setNewAllDropDown] =
    useRecoilState(newAllDropDownState);

  const [createPatientStep2, setCreatePatientStep2] = useRecoilState(
    createPatientStep2State,
  );
  const [patientDetails, setpatientDetails] = useRecoilState(PatientState);
  const [patientInfo, setpatientInfo] = useRecoilState(PatientState);
  const [isDisabled, setIsDisabled] = useState(true);
  const [recentSearchHistory, setRecentSearchHistory] = useState<
    recentSearch[]
  >([]);
  const [searchData, setsearchData] = useState<string[]>([]);
  const [searchData1, setsearchData1] = useState<string[]>([]);
  const [businessType, setBusinessType] = useState<number>(0);
  const [patientClicked, setPatientClicked] = useState<boolean>(false);
  const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
    networkConnectionStatus,
  );
  const [word, setWord] = useState("");
  let history = useHistory();
  const _location = useLocation();
  const prevLocationRef = useRef<{ pathname: string }>();
  // console.log("history", history)
  const {
    register,
    setError,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});

  let Window = window as any;
  Window["HomeComponentReference"] = {
    component: this,
    SetDeviceId: SetDeviceId,
  };

  function SetDeviceId(deviceInfo: any) {
    debugger;
    localStorage.setItem("device_id", deviceInfo);
    console.log("hn g unique id:", deviceInfo);
    Sentry.setTag("Device_Unique_Id", JSON.stringify(deviceInfo));
    Sentry.captureMessage("Device info tag test");
    // Sentry.captureException(new Error("Test error for device info"));
  }

  useEffect(() => {
    deviceUniqueId();
  }, []);

  async function GetPatientDetails(
    patientId: number,
    isSearch: boolean,
    fullName: string,
    dob: Date,
  ) {
    debugger;
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setpatientName("");
    var bType = localStorage.getItem("BusinessType") || 1;
    if (
      isSearch &&
      (businessType === 0 ? Number(bType) : businessType) === BusinessType.Cloud
    ) {
      await AddUpdateMobileWorkstationPatient({
        PatientId: Number(patientId),
        localDateTime: localDateTime(),
        applicationLookup: 5,
      }).then(async function (response) {
        debugger;
        if (response && response?.data && response?.data?.responseCode !== 0) {
          patientId = response?.data.id;
        }
      });
    }
    localStorage.setItem("patientServerID", patientId.toString());

    SaveRecentSearch(fullName, patientId, dob);
    setNewAllDropDown(dummyDropDowns);
    setCreatePatientStep2(false);
    setIsDisabled(true);
    setShowModal(false);
    localStorage.setItem("patientdob", dob.toString());
    history.replace("/patient-page", {
      patientToEdit: {},
    });
    //try {
    //  await GetPatientById({
    //    PatientId: Number(patientId),
    //    localDateTime: localDateTime(),
    //    EncryptedServerId: localStorage.getItem("EncryptedServerId"),
    //  })
    //    .then(async function (response) {
    //      debugger;
    //      if (response!.data.responseCode !== 0) {

    //        // setpatientInfo(...response!.data.patientVM, referralId : response!.data.patientVM.referralSourceId)
    //        setpatientInfo((prevState: PatientVM) => ({
    //          ...prevState,
    //          ...response!.data.patientVM,
    //          referralId: response!.data.patientVM.referralSourceId,
    //        }));

    //        // console.log("setting patientServerID");

    //        // localStorage.setItem("patientServerID",  response!.data.patientVM.id);

    //      } else {
    //        setError("patientName", {
    //          type: "server",
    //          message: response!.data.responseMessage,
    //        });
    //      }
    //    })
    //    .catch((error) => {
    //      history.push("/confirmation", {
    //        actionType: ActionType.FailureAPIResponse,
    //      });
    //    });
    //} catch (error) {
    //  history.push("/confirmation", {
    //    actionType: ActionType.FailureAPIResponse,
    //  });
    //  console.error(error);
    //}
  }
  async function SaveRecentSearch(
    fullName: string,
    patientid: number,
    dob: Date,
  ) {
    try {
      await SaveRecentSearchAuth({
        loggedInUserID: 0,
        search: {
          fullName: fullName,
          patientid: patientid,
          dob: dob,
        },
      })
        .then(async function (response) {
          if (response!.data.isResponseSuccessfull) {
          } else {
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }
  async function GetRecentSearches() {
    debugger;
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    try {
      await GetRecentSearchesAuth({
        loggedInUserID: 0,
      })
        .then(async function (response) {
          debugger;
          // if (response!.data.isResponseSuccessfull) {
          if (response!.data.responseCode !== 0) {
            // console.log(response!.data.recentSearchData)
            setRecentSearchHistory(response!.data.recentSearchData);
          } else {
            //  history.push("/confirmation", { actionType: ActionType.FailureAPIResponse });
          }
        })
        .catch((error) => {
          history.push("/confirmation", {
            actionType: ActionType.FailureAPIResponse,
          });
        });
    } catch (error) {
      history.push("/confirmation", {
        actionType: ActionType.FailureAPIResponse,
      });
      console.error(error);
    }
  }
  // function setSearchWord(word: string) {
  //   setWordEntered(word);
  // }
  async function handleClick() {
    if (!navigator.onLine) {
      setShowNetWorkRecoil({ isShown: true });
      return;
    }
    setShowModal(false);
    setsearchData1([]);
    setWord("");
    setCreatePatientStep2(false);
    setpatientDetails(dummyPatient);
    setNewAllDropDown(resetDropDowns);
    history.push("/create-edit-patient", { props: false });
  }

  let location =
    window.location.href == window.location.origin + "/home" ? true : false;
  useEffect(() => {
    prevLocationRef.current = _location;
    // console.log("useEffect home")
    if (window.location.href.includes("home")) {
      getMobileUIVersion();
      GetRecentSearches();
      setIsPccCheck(localStorage.getItem("isPccEnabled") === "true");
    }

    return () => {
      setsearchData([]);
      setIsPccCheck(false);
    };
  }, [location]);

  const isForward = prevLocationRef.current?.pathname !== _location.pathname;

  // console.log("searchData", searchData);
  return (
    <>
      <IonPage placeholder={undefined}>
        <IonHeader className="ion-no-border" placeholder={undefined}>
          <TopLeftUserName headerText={"Select a Patient"}></TopLeftUserName>
        </IonHeader>
        <IonContent
          className={"keybordOffset slide-in-right"}
          placeholder={undefined}
        >
          <IonGrid
            className="container home-page-top-spacing"
            placeholder={undefined}
          >
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                {/* <div className="field-wrap"> */}
                <IonLabel className="label" placeholder={undefined}>
                  Patient Search
                </IonLabel>
                <div className="field-wrap">
                  <SearchBar
                    setShowModal={setShowModal}
                    setpatientName={setpatientName}
                    setIsDisabled={setIsDisabled}
                    placeholder="Search"
                    data={searchData}
                    setsearchData={setsearchData}
                    setFilteredData1={setsearchData1}
                    GetPatientDetails={GetPatientDetails}
                    setWord={setWord}
                    setBusinessType={setBusinessType}
                    SaveRecentSearch={SaveRecentSearch}
                    isPccCheck={isPccCheck}
                  />
                  {isPccEnabled && (
                    <label className="is-pcc-checkbox-wrap">
                      <IonCheckbox
                        className="is-pcc-checkbox"
                        checked={isPccCheck}
                        onIonChange={(e) => {
                          setIsPccCheck(e.detail.checked);
                          setWord("");
                          setsearchData([]);
                          setsearchData1([]);
                        }}
                        placeholder={undefined}
                      />
                      <span className="is-pcc-label">PCC</span>
                    </label>
                  )}
                </div>
                {word.length < 3 && (
                  <div className="recent-search">
                    {recentSearchHistory.length > 0 && (
                      <>
                        <h4 className="patient-search">Recent Patients</h4>
                        <div className="search-patient-list search-patient-list-adjustment">
                          <ul>
                            {recentSearchHistory.length == 0 ? (
                              <li>No search history</li>
                            ) : (
                              recentSearchHistory.map((obj: any) => (
                                <li key={obj.patientId}>
                                  <div
                                    className={
                                      "d-flex justify-content-between" +
                                      (patientClicked
                                        ? " disabled-patient"
                                        : "")
                                    }
                                    onClick={() => {
                                      if (patientClicked) return;
                                      setPatientClicked(true);
                                      localStorage.setItem(
                                        "patientName",
                                        obj.fullName,
                                      );
                                      const businessType =
                                        localStorage.getItem("BusinessType") ||
                                        1;
                                      localStorage.setItem(
                                        "patientMasterID",
                                        Number(businessType) ===
                                          BusinessType.Cloud
                                          ? obj.masterUserId
                                          : obj.patientId,
                                      );
                                      GetPatientDetails(
                                        Number(businessType) ===
                                          BusinessType.Cloud
                                          ? obj.masterUserId
                                          : obj.patientId,
                                        true,
                                        obj.fullName,
                                        obj.dob,
                                      );
                                    }}
                                  >
                                    <h6>{obj.fullName}</h6>
                                    <div className="date-new-values">
                                      <a>
                                        {format(
                                          new Date(obj?.dob),
                                          "MM/dd/yyyy",
                                        )}
                                      </a>
                                    </div>
                                  </div>
                                </li>
                              ))
                            )}
                          </ul>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
        <IonFooter className="ion-no-border" placeholder={undefined}>
          <IonGrid className="container" placeholder={undefined}>
            <IonRow className="row" placeholder={undefined}>
              <IonCol className="col-sec" placeholder={undefined}>
                <div className="btn-wrap-sec">
                  {/* <IonButton
                    className="generic-btn"
                    disabled={isDisabled}
                    onClick={() => {
                      GetPatientDetails(localStorage.getItem("patientServerID")!);
                    }}
                  >Start Session</IonButton> */}
                  <IonButton
                    className="generic-btn bg-blue"
                    onClick={handleClick}
                    placeholder={undefined}
                  >
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="c-plus-icon"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16 2L2 2L2 16L16 16L16 2ZM2 6.55651e-07L16 0C17.1046 1.19209e-07 18 0.895431 18 2L18 16C18 17.1046 17.1046 18 16 18L2 18C0.89543 18 5.96046e-07 17.1046 6.55651e-07 16L0 2C1.19209e-07 0.89543 0.895432 5.96046e-07 2 6.55651e-07Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M4 9C4 8.44771 4.44772 8 5 8H13C13.5523 8 14 8.44771 14 9C14 9.55229 13.5523 10 13 10H5C4.44772 10 4 9.55229 4 9Z"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9 4C9.55228 4 10 4.44772 10 5V13C10 13.5523 9.55229 14 9 14C8.44772 14 8 13.5523 8 13V5C8 4.44772 8.44771 4 9 4Z"
                        fill="white"
                      />
                    </svg>
                    Create New Patient
                  </IonButton>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonFooter>
      </IonPage>
    </>
  );
};
export default Home;
